var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewBlueInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7812 10.1387C20.7812 15.6615 16.3041 20.1387 10.7812 20.1387C5.2584 20.1387 0.78125 15.6615 0.78125 10.1387C0.78125 4.61582 5.2584 0.138672 10.7812 0.138672C16.3041 0.138672 20.7812 4.61582 20.7812 10.1387ZM11.5559 14.0515C11.5559 13.6237 11.2091 13.2769 10.7813 13.2769C10.3534 13.2769 10.0066 13.6237 10.0066 14.0515C10.0066 14.4793 10.3534 14.8262 10.7813 14.8262C11.2091 14.8262 11.5559 14.4793 11.5559 14.0515ZM11.4222 5.99084C11.391 5.68801 11.1159 5.45117 10.7813 5.45117C10.4257 5.45117 10.1374 5.71854 10.1374 6.04835V11.2919L10.1404 11.3494C10.1716 11.6522 10.4466 11.8891 10.7813 11.8891C11.1369 11.8891 11.4251 11.6217 11.4251 11.2919V6.04835L11.4222 5.99084Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBlueInfoIcon);
export default __webpack_public_path__ + "static/media/new-blue-info-icon.f3d93c64238ef41dae2044c8e9729c0e.svg";
export { ForwardRef as ReactComponent };